import { store } from 'quasar/wrappers'
import { createPinia } from 'pinia'
import type { Router } from 'vue-router'

/*
 * When adding new properties to stores, you should also
 * extend the `PiniaCustomProperties` interface.
 * @see https://pinia.vuejs.org/core-concepts/plugins.html#typing-new-store-properties
 */
declare module 'pinia' {
  export interface PiniaCustomProperties {
    readonly router: Router
  }
}

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default store(() => {
  const pinia = createPinia()

  // You can add Pinia plugins here
  // pinia.use(SomePiniaPlugin)

  return pinia
})

export * from './app.store'
export * from './debug.store'
export * from './org.store'
export * from './per.store'
export * from './agg.store'
export * from './settlement.store'
export * from './processing.store'
export * from './res.store'
export * from './att.store'
export * from './device.store'
export * from './journal.store'
export * from './pushNotification.store'
export * from './notification.store'
export * from './kiosk.store'
export * from './messaging.store'
export * from './signalr.store'
export * from './appConfiguration.store'
